// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bosnia from '../_raw/flag/icon_flag_bosnia.png';

export default () => <img src={Bosnia} alt="Bosnia" />;
